const PANEL_SELECTOR = '[data-iq-form-panel]';
const HEAD_CLASS = 'iq-field-head';
const APPLIED_CLASS = 'iq-field-head-applied';
const RESOLVE_TIMEOUT = 15000;

function readLabel(field) {
  const labelled = field.querySelector('[data-label]');
  if (labelled && labelled.dataset.label) return labelled.dataset.label.trim();

  const content = field.querySelector('.label-content');
  return content ? content.textContent.trim() : '';
}

const ABSOLUTE_TARGET = /^(#|\/|https?:|mailto:|tel:)/i;
const FALLBACK_TARGET_ID = 'iq-scroll-target';

/**
 * A target may be given as a fragment or as a CSS selector. A selector is
 * resolved to the matching element's own id, so the anchor keeps a real
 * fragment for href and does not depend on a section's generated id.
 */
function resolveTarget(href) {
  if (ABSOLUTE_TARGET.test(href)) return href;

  let element = null;
  try {
    element = document.querySelector(href);
  } catch {
    return href;
  }
  if (!element) return href;

  if (!element.id) element.id = FALLBACK_TARGET_ID;
  return `#${element.id}`;
}

function buildHead(panel, title) {
  const head = document.createElement('div');
  head.className = HEAD_CLASS;

  const heading = document.createElement('span');
  heading.className = `${HEAD_CLASS}__title`;
  heading.textContent = title;
  head.append(heading);

  const { fieldLinkHref: href, fieldLinkLabel: label } = panel.dataset;
  if (href && label) {
    const link = document.createElement('a');
    link.className = `${HEAD_CLASS}__link`;
    link.href = resolveTarget(href);
    link.textContent = label;

    if (link.getAttribute('href').startsWith('#')) {
      // scroll-to-target cancels the jump, so the fragment never hits the URL.
      const scroller = document.createElement('scroll-to-target');
      scroller.className = `${HEAD_CLASS}__scroller`;
      scroller.append(link);
      head.append(scroller);
    } else {
      head.append(link);
    }
  }

  return head;
}

function promote(panel) {
  const selector = panel.dataset.fieldSelector;
  if (!selector) return true;

  const field = panel.querySelector(selector);
  if (!field) return false;
  if (field.classList.contains(APPLIED_CLASS)) return true;

  const title = readLabel(field);
  if (!title) return false;

  field.prepend(buildHead(panel, title));
  field.classList.add(APPLIED_CLASS);
  return true;
}

function watch(panel) {
  if (promote(panel)) return;

  const observer = new MutationObserver(() => {
    if (promote(panel)) observer.disconnect();
  });

  observer.observe(panel, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), RESOLVE_TIMEOUT);
}

document.querySelectorAll(PANEL_SELECTOR).forEach(watch);
